import { decimalsToWei, Fraction } from '@akropolis-web/primitives';

const SIGNIFICANT_FRACTION_NUMBERS = 3;
export function calcSignificantValue(tokenDecimals: number): Fraction {
  return new Fraction(decimalsToWei(Math.max(0, tokenDecimals - SIGNIFICANT_FRACTION_NUMBERS)));
}
